export const HEADER_TRANSLATION_KEY = 'b2b-header';
